import { useIntl } from 'react-intl'

import {
  FEATURE_TOGGLE_SELLER_CENTRAL,
  useFeatureToggle,
} from '../../feature-toggles'
import { useGlobalConfigContext } from '../../global-config'

import { useMarketplacePartnerRegisterPageGetDictionaryByName } from './useMarketplacePartnerRegisterPageGetDictionaryByName'

export const useMarketplacePartnerRegisterPageFormDictionary = (): {
  middlewarePartnerOptions: string[]
  shopSystemOptions: string[]
} => {
  const intl = useIntl()
  const { language } = useGlobalConfigContext()
  const isSellerCentralFeatureEnabled = useFeatureToggle(
    FEATURE_TOGGLE_SELLER_CENTRAL,
  )

  const sellerCentralMiddlewarePartners =
    useMarketplacePartnerRegisterPageGetDictionaryByName(
      'middlewarePartners',
      language,
    )

  // Options for the middleware partner select input, static values will be removed after releasing seller central to production. WSCR-3860
  const middlewarePartnerOptions =
    isSellerCentralFeatureEnabled && sellerCentralMiddlewarePartners
      ? sellerCentralMiddlewarePartners
      : [
          'Base',
          'Brickfox',
          'Channel Advisor',
          'Channable',
          'ChannelEngine',
          'Channel Pilot Pro',
          'eCommeleon',
          'JTL',
          'plentymarkets',
          'Speed4Trade',
          'Tradebyte',
          'Xentral',
          intl.formatMessage({
            id: 'marketplacePartnerRegisterPage.technicalInformations.middlewarePartner.other',
          }),
          intl.formatMessage({
            id: 'marketplacePartnerRegisterPage.technicalInformations.middlewarePartner.noPartner',
          }),
        ]

  const sellerCentralShopSystems =
    useMarketplacePartnerRegisterPageGetDictionaryByName(
      'shopSystems',
      language,
    )
  const shopSystemOptions =
    isSellerCentralFeatureEnabled && sellerCentralShopSystems
      ? sellerCentralShopSystems
      : [
          // List of shop systems, will be deleted after releasing seller central to production. WSCR-3860
          'JTL Shop',
          'Magento 2',
          'OXID eshop',
          'PrestaShop',
          'Shopify',
          'Shopware 5',
          'Shopware 6',
          'WooCommerce',
          intl.formatMessage({
            id: 'marketplacePartnerRegisterPage.technicalInformations.shopSystem.other',
          }),
        ]

  return { middlewarePartnerOptions, shopSystemOptions }
}
